module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Krypton-cropped.59d1e88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Krypton-cropped.jpg
// module id = 0IaL
// module chunks = 0